export async function registerServiceWorker(): Promise<ServiceWorkerRegistration | null> {
  if (!('serviceWorker' in navigator)) {
    return null
  }

  // Defer registration until page is fully loaded to avoid "invalid state" errors
  // that occur when the <base> tag hasn't settled yet
  if (document.readyState !== 'complete') {
    return new Promise((resolve) => {
      window.addEventListener('load', () => resolve(doRegister()), { once: true })
    })
  }
  return doRegister()
}

async function doRegister(): Promise<ServiceWorkerRegistration | null> {
  try {
    // Build absolute SW URL from page origin + pathname prefix to avoid
    // <base> tag interference with relative URL resolution
    const pageUrl = new URL(window.location.href)
    // Strip trailing filename to get directory, ensure trailing slash
    const dir = pageUrl.pathname.replace(/\/[^/]*$/, '/')
    const swUrl = `${dir}sw.js`
    const registration = await navigator.serviceWorker.register(swUrl, { scope: dir })
    console.log('[PWA] Service worker registered, scope:', registration.scope)
    return registration
  } catch (error) {
    console.error('[PWA] Service worker registration failed:', error)
    return null
  }
}
